
(() => {
  function initCategory(root = document) {
    root.querySelectorAll('[data-swiper="pd-subcategories"]').forEach((slider) => {
      if (slider.dataset.pdReady === 'true') return;
      slider.dataset.pdReady = 'true';
      const container = slider.closest('[data-pd-subcategory-section]') || document;
      const progress = container.querySelector('[data-swiper-progress="pd-subcategories"]');
      const prevButton = container.querySelector('.pd-subcategory-prev');
      const nextButton = container.querySelector('.pd-subcategory-next');
      if (window.Swiper) {
        const swiper = new window.Swiper(slider, {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 48,
          rewind: true,
          watchOverflow: true,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton
          },
          breakpoints: {
            0: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 24 },
            768: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 32 },
            1200: { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 48 }
          },
          on: {
            init(item) { updateSubcategoryOverflow(item, container, progress); },
            slideChange(item) { updateSubcategoryOverflow(item, container, progress); },
            progress(item) { updateSubcategoryOverflow(item, container, progress); },
            resize(item) { updateSubcategoryOverflow(item, container, progress); },
            lock(item) { updateSubcategoryOverflow(item, container, progress); },
            unlock(item) { updateSubcategoryOverflow(item, container, progress); }
          }
        });
        updateSubcategoryOverflow(swiper, container, progress);
      } else {
        initNativeCarousel(slider, prevButton, nextButton, progress);
      }
    });

    root.querySelectorAll('[data-filter-group]').forEach((group) => {
      if (group.dataset.pdReady === 'true') return;
      group.dataset.pdReady = 'true';
      const toggle = group.querySelector('.pd-filter-toggle');
      const content = group.querySelector('.pd-filter-content');
      if (!toggle || !content) return;
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        group.classList.toggle('pd-filter-group--open', !expanded);
        content.hidden = expanded;
      });
    });

    root.querySelectorAll('[data-range-slider]').forEach((slider) => {
      if (slider.dataset.pdReady === 'true') return;
      slider.dataset.pdReady = 'true';
      const track = slider.querySelector('[data-range-track]');
      const minInput = slider.querySelector('[data-range-min]');
      const maxInput = slider.querySelector('[data-range-max]');
      const minHidden = slider.querySelector('[data-range-min-hidden]');
      const maxHidden = slider.querySelector('[data-range-max-hidden]');
      if (!track || !minInput || !maxInput) return;
      let submitTimer;
      const update = () => {
        const min = Number(minInput.min || 0);
        const max = Number(minInput.max || 0);
        let minValue = Number(minInput.value || 0);
        let maxValue = Number(maxInput.value || max);
        const step = Number(minInput.step || 1);
        if (minValue > maxValue - step) {
          minValue = maxValue - step;
          minInput.value = String(minValue);
        }
        if (maxValue < minValue + step) {
          maxValue = minValue + step;
          maxInput.value = String(maxValue);
        }
        const minPercent = max > min ? ((minValue - min) / (max - min)) * 100 : 0;
        const maxPercent = max > min ? ((maxValue - min) / (max - min)) * 100 : 100;
        track.style.setProperty('--range-min', minPercent + '%');
        track.style.setProperty('--range-max', maxPercent + '%');
        const minLabel = slider.querySelector('[data-range-min-label]');
        const maxLabel = slider.querySelector('[data-range-max-label]');
        if (minLabel) minLabel.textContent = money(minValue);
        if (maxLabel) maxLabel.textContent = money(maxValue);
        if (minHidden) minHidden.value = minValue > min ? String(minValue) : '';
        if (maxHidden) maxHidden.value = maxValue < max ? String(maxValue) : '';
      };
      const scheduleSubmit = () => {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(() => slider.closest('form')?.requestSubmit(), 450);
      };
      minInput.addEventListener('input', update);
      maxInput.addEventListener('input', update);
      minInput.addEventListener('change', scheduleSubmit);
      maxInput.addEventListener('change', scheduleSubmit);
      update();
    });

    root.querySelectorAll('[data-sort-option]').forEach((button) => {
      if (button.dataset.pdReady === 'true') return;
      button.dataset.pdReady = 'true';
      button.addEventListener('click', () => {
        const value = button.dataset.sortOption;
        if (!value) return;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      });
    });

    root.querySelectorAll('.pd-faq-item button').forEach((button) => {
      if (button.dataset.pdReady === 'true') return;
      button.dataset.pdReady = 'true';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const answer = button.nextElementSibling;
        button.setAttribute('aria-expanded', String(!expanded));
        if (answer) answer.hidden = expanded;
      });
    });
  }

  function initNativeCarousel(slider, prevButton, nextButton, progress) {
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (wrapper) wrapper.style.width = 'max-content';
    slider.style.overflowX = 'auto';
    slider.style.scrollBehavior = 'smooth';
    const scrollAmount = () => Math.max(180, slider.clientWidth * 0.72);
    const updateNativeProgress = () => {
      const container = slider.closest('[data-pd-subcategory-section]');
      const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;
      container?.classList.toggle('pd-subcategory-wrap--overflow', hasOverflow);
      if (!progress) return;
      const maxScroll = Math.max(slider.scrollWidth - slider.clientWidth, 1);
      const percent = Math.max(12, Math.min(((slider.scrollLeft / maxScroll) * 88) + 12, 100));
      progress.style.setProperty('--progress-width', percent + '%');
    };
    prevButton?.addEventListener('click', () => slider.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    nextButton?.addEventListener('click', () => slider.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    slider.addEventListener('scroll', updateNativeProgress, { passive: true });
    updateNativeProgress();
  }

  function updateSubcategoryOverflow(swiper, container, progress) {
    if (!swiper || !container) return;
    container.classList.toggle('pd-subcategory-wrap--overflow', !swiper.isLocked);
    updateProgress(swiper, progress);
  }

  function updateProgress(swiper, progress) {
    if (!progress || !swiper) return;
    const visible = swiper.slidesPerViewDynamic ? swiper.slidesPerViewDynamic() : 1;
    const total = Math.max(swiper.slides.length - visible + 1, 1);
    const current = Math.min(swiper.activeIndex + 1, total);
    const percent = Math.max(12, Math.min((current / total) * 100, 100));
    progress.style.setProperty('--progress-width', percent + '%');
  }

  function money(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0
    }).format(Number(value || 0));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCategory());
  } else {
    initCategory();
  }

  document.addEventListener('shopify:section:load', (event) => initCategory(event.target));
})();
